import React from 'react';

import { Empty as AntEmpty } from 'antd';

export default function Empty() {
  return <AntEmpty description="No results found" />;
}
